/*
 * File: Copyright.tsx
 * Desc: 版权信息
 * File Created: 2020-04-12 22:50:33
 * Author: chenghao
 * ------
 * Copyright 2020 - present, karakal
 */
import React from 'react';

const Copyright = () => {
    return (
        <div>
            <p style={{color:'#666'}}>Copyright @ 2019-{new Date().getFullYear()} 斗球 ALL Rights Reserved</p>
        </div>
    );
};

export default Copyright;
